import { render, staticRenderFns } from "./parentStarCard.vue?vue&type=template&id=0b1eaec0&scoped=true&"
import script from "./parentStarCard.vue?vue&type=script&lang=js&"
export * from "./parentStarCard.vue?vue&type=script&lang=js&"
import style0 from "./parentStarCard.vue?vue&type=style&index=0&id=0b1eaec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1eaec0",
  null
  
)

export default component.exports